import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { IPOLStats } from '../../api/interfaces'
import { IChart, IChartConfig } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'
import { colors } from '../../const'

export async function getTreasuryMSigDeploymentsConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_treasury_pol_stats', timeframe)) as IPOLStats[]
	const pools = [
		'BASE.ETH',
		'BASE.USDC-0X833589FCD6EDB6E08F4C7C32D4F71B54BDA02913',
		'BSC.BTCB-0X7130D2A12B9BCBFAE4F2634D864A1EE1CE3EAD9C',
		'BSC.BUSD-0XE9E7CEA3DEDCA5984780BAFC599BD69ADD087D56',
		'BSC.ETH-0X2170ED0880AC9A755FD29B2688956BD959F933F8',
		'THOR.TCY',
		'TRON.TRX',
		'TRON.USDT-TR7NHQJEKQXGTCI8Q8ZY4PL8OTSZGJLJ6T',
		'XRP.XRP'
	]
	const assetData: IPOLStats[][] = []
	const seriesData: { x: number; y: number }[][] = []
	const config: IChart[] = []
	pools.forEach((pool) => {
		assetData.push(chartData.filter((row) => row.POOL_NAME === pool))
	})
	assetData.forEach((asset) => {
		seriesData.push(
			asset.map((element: IPOLStats) => {
				return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_DEPOSITED_RUNE - element.TOTAL_WITHDRAWN_RUNE }
			})
		)
	})
	const series1 = assetData[0].map((element: IPOLStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_CURRENT_VALUE_RUNE }
	})
	const series5 = (() => {
		const sumByDay = new Map<number, number>()

		for (const series of [seriesData[0], seriesData[1], seriesData[2], seriesData[3], seriesData[4], seriesData[5], seriesData[6], seriesData[7], seriesData[8]]) {
			for (const { x, y } of series) {
				sumByDay.set(x, (sumByDay.get(x) ?? 0) + y)
			}
		}

		return Array.from(sumByDay, ([x, y]) => ({ x, y })).sort((a, b) => a.x - b.x)
	})()
	config.push({
		data: series1,
		strokeWidth: 2,
		name: `Current Value`,
		type: 'line',
		seriesGroup: '[rune]',
		color: `${color}`,
		unitSymbol: 'ᚱ'
	})
	config.push({
		data: series5,
		strokeWidth: 2,
		name: `Total Deposited`,
		type: 'line',
		seriesGroup: '[rune]',
		color: `${colors[0]}`,
		unitSymbol: 'ᚱ'
	})
	let i = 0
	seriesData.forEach((series) => {
		config.push({
			data: series,
			strokeWidth: 2,
			name: pools[i].split('-')[0].toUpperCase(),
			type: 'line',
			seriesGroup: '[rune]',
			color: colors[i + 1],
			unitSymbol: 'ᚱ'
		})
		i++
	})

	return { config: config, latestValue: 0, latestValueDate: 0 }
}

const TreasuryMSigDeployments = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getTreasuryMSigDeploymentsConfig, '1m')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Total Net Treasury Multisig Deployments"
			chartDesc={`Total Treasury Multisig deployments subtracted by withdrawals stacked by recipient pool.\n Tracking address: thor10qh5272ktq4wes8ex343ky9rsuehcypddjh08k`}
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="88fdb846-eb56-4576-bcf0-af576c4443e0"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			hasLogScale={false}
			sortByValueDesc={true}
		/>
	)
}

export default TreasuryMSigDeployments
